import { capitalize } from 'lodash';

import { ConversationJobProgress } from '@/explore/types';

import { StatusMessageContent } from './status-message-content';

import styles from './progress-list.module.scss';

const formatTime = (createdAt: string): string => {
  return new Date(createdAt).toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
};

interface ProgressListProps {
  progress: ConversationJobProgress[];
  onClose: () => void;
}

export const ProgressList = ({ progress, onClose }: ProgressListProps) => {
  return (
    <div
      className={styles.progressContainer}
      onClick={(e) => {
        e.stopPropagation();
        onClose();
      }}>
      {progress.map((item) => {
        const time = formatTime(item.createdAt);
        const statusMessage = item.statusMessage ?? capitalize(item.status);
        return (
          <div key={item.jobProgressId} className={styles.progressItem}>
            <span className={styles.progressTime}>{time}</span>
            <div className={styles.progressMessage}>
              <StatusMessageContent content={statusMessage} uniqueId={item.jobProgressId} />
            </div>
          </div>
        );
      })}
    </div>
  );
};
